"use client";
import { useEffect, useRef } from "react";
import { useBrowserSession } from "../../session/use-browser-session";
import { AnalyticsProperties } from "./analytics-properties";
import { identifyAnalyticsUser, resetAnalyticsUser } from "./client";
import { analyticsSurfaces } from "./surfaces";

export function MainSiteAnalyticsContext() {
  const { session, kind: status } = useBrowserSession();
  const lastIdentifiedUserIdRef = useRef<string | null>(null);
  useEffect(() => {
    if (status === "pending") {
      return;
    }

    const userId = session?.user?.id ?? null;

    if (!userId) {
      if (lastIdentifiedUserIdRef.current) {
        resetAnalyticsUser();
        lastIdentifiedUserIdRef.current = null;
      }

      return;
    }

    const email = session?.user?.email ?? null;
    identifyAnalyticsUser({ userId, email });
    lastIdentifiedUserIdRef.current = userId;
  }, [session?.user?.email, session?.user?.id, status]);
  return (
    <AnalyticsProperties properties={{ surface: analyticsSurfaces.mainSite }} />
  );
}
